var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    attrs: {
      "id": "app"
    }
  }, [_vm.accessToken ? _c('console-app', {
    attrs: {
      "title": "MEVN2 관리자 메뉴"
    }
  }, [_c('router-view')], 1) : _c('console-sign-in')], 1);

}
var staticRenderFns = []

export { render, staticRenderFns }